import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../../views/ReportView/ReportView.module.css";
import { FaRegAddressCard } from "react-icons/fa";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaCity } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { BajaButtonCompany, AltaButtonCompany } from "../";

const HeaderReviewCompany = ({ data }) => {
  const [company, setCompany] = useState(data);
  const navigate = useNavigate();

  const handleEditCompany = async (e, cuit) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        process.env.REACT_APP_LEALTAD_UPDATE_COMPANY_API,
        {
          id: cuit,
        }
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: "La Persona Jurídica se actualizo correctamente",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Parece que hubo un error al actualizar a la Persona Jurídica",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  const handlerNavigateUpdate = (e, data) => {
    e.preventDefault();
    navigate("/lealtad/informe/actualizar", { state: { data } });
  };

  const handlePdf = (e, data) => {
    e.preventDefault();
    navigate("/lealtad/informe/imprimir-pdf", { state: { data } });
  };

  const changeColoResult = () => {
    if (company.RiskCompany.data === "Riesgo bajo") {
      return (
        <div className={styles.LealtadmdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.Lealtadmdrlow}>{company.RiskCompany.data}</p>
        </div>
      );
    } else if (company.RiskCompany.data === "Riesgo medio") {
      return (
        <div className={styles.LealtadmdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.Lealtadmdrmid}>{company.RiskCompany.data}</p>
        </div>
      );
    } else {
      return (
        <div className={styles.LealtadmdrResult}>
          <h4>Resultado del perfil:</h4>
          <p className={styles.Lealtadmdrheig}>{company.RiskCompany.data}</p>
        </div>
      );
    }
  };

  return (
    <div className={styles.LealtadInfo}>
      {!company ? (
        <NotReportViewData title="Información" Icon={FaCity} />
      ) : (
        <>
          <div className={styles.LealtadsectionTitle}>
            <h2 className={styles.Lealtadtitle}>
              <FaRegAddressCard className={styles.Lealtadicon} /> {company.cuit}{" "}
              |{" " + company.companyName}
            </h2>
            <div className={styles.LealtadbuttonsContainerfelx}>
              <div className={styles.LealtadbuttonsContainer}>
                {company.status === "Alta" ? (
                  <BajaButtonCompany
                    company={company}
                    setCompany={setCompany}
                  />
                ) : (
                  <AltaButtonCompany
                    company={company}
                    setCompany={setCompany}
                  />
                )}
              </div>
              <div className={styles.LealtadbuttonsContainer}>
                <button
                  className={styles.Lealtadbutton}
                  onClick={(e) => handlePdf(e, data)}
                >
                  <i className="fa fa-refresh"></i> Imprimir Informe
                </button>
              </div>
              <div className={styles.LealtadbuttonsContainer}>
                <button
                  className={styles.Lealtadbutton}
                  onClick={(e) => handleEditCompany(e, company.cuit)}
                >
                  <i className="fa fa-refresh"></i> Actualizar por Nosis
                </button>
              </div>
              <div className={styles.LealtadbuttonsContainer}>
                <button
                  id={styles.Lealtadidbuton}
                  className={styles.Lealtadbutton}
                  onClick={(e) => handlerNavigateUpdate(e, company)}
                >
                  <i className="fa fa-refresh"></i> Actualizar a Mano
                </button>
              </div>
            </div>
          </div>
          {changeColoResult()}
        </>
      )}
    </div>
  );
};

export default HeaderReviewCompany;
